import NetworkUtil from "./NetworkUtil";
import {Kit} from "../types/Kit";
import {ServerResponse} from "../types/ServerResponse";

export default class InventoryAPI {

    public static async getAllKitInventoryData():Promise<{success:boolean, reason:string, data}>{
        return NetworkUtil.makeGet("/api/admin/kitInventory");
    }

    public static async filterKitInventory(filter):Promise<{success:boolean, reason:string, data}>{
        return NetworkUtil.makePost("/api/admin/kitInventory/filter", filter)
    }

    public static async createKit(kit:Kit):Promise<ServerResponse>{
        return NetworkUtil.makePost("/api/admin/kitInventory/create", kit)
    }

    public static async createInventory(filter):Promise<boolean>{
        return NetworkUtil.downloadCSV("/api/admin/kitInventory/createInventory", "kit_inventory.xlsx", filter)
    }
    
    public static async editKit(kit):Promise<ServerResponse>{
        return NetworkUtil.makePost("/api/admin/kitInventory/edit", kit)
    }

}